export default __webpack_public_path__ + "static/media/playstation.18cc4b9c.svg";